import * as React from "react";
import { CheckIcon } from "@chakra-ui/icons";
import {
  Container,
  Flex,
  Grid,
  GridItem,
  Heading,
  HStack,
  Text,
  VStack
} from "@chakra-ui/react";

import { IGatsbyImageData } from "gatsby-plugin-image";

import { Carousel } from "../../common/Carousel";
import { MediaImage } from "../../common/Media";


interface Props {
  heading: string
  areas: any[]
  flexDirection: "row" | "row-reverse"
  image: IGatsbyImageData
  imagePosition: "top" | "right" | "bottom" | "left"
  imageMaxW?: object | string[] | string
  imageMaxH?: object | string[] | string
  alt: string
};


export const ServiceAreasFlexbox: React.FC<Props> = ( props ) => {
  return (
    <Flex
      flexDirection={{
        base: 'column',
        lg: `${ props.flexDirection }`
      }}
      alignItems={{
        lg: 'center'
      }}
      w="100%"
    >
      <MediaImage
        flex={{
          lg: '1 1 0%'
        }}
        containerWidth={{
          xl: '100%'
        }}
        containerHeight={{
          base: '450px',
          lg: '651px',
          '2xl': '806px'
        }}
        image={ props.image }
        alt={ props.alt }
        objectFit="none"
        background="primary.100"
        borderRadius={{
          base: '0',
          lg: props.flexDirection === "row" ? '0px 24px 24px 0px' : '24px 0px 0px 24px'
        }}
        position={ props.imagePosition }
        imageMaxW={ props.imageMaxW }
        imageMaxH={ props.imageMaxH }
      />
      <Flex
        display={{
          base: 'none',
          lg: 'flex'
        }}
        flex="1 1 0%"
        justifyContent="center"
      >
        <VStack
          spacing={ 10 }
          align={{
            lg: 'flex-start'
          }}
          w={{
            lg: '450px'
          }}
        >
          <Heading
            as="h3"
            color="accent.900"
            fontSize="32px"
            fontWeight={ 400 }
            lineHeight="36px"
          >
            { props.heading }
          </Heading>
          <Grid
            templateColumns="1fr 1fr"
            gap="24px 48px"
          >
            { props.areas.map( ( areaGroup: any[], _groupIndex: number ) => {
              console.log(areaGroup);

              return (
                <>
                  { areaGroup.map( ( area: string, _index: number ) => {
                    console.log(area);
                    return (
                      <GridItem
                        key={ _index }
                      >
                        <HStack
                          spacing={ 4 }
                        >
                          <Flex
                            justifyContent="center"
                            alignItems="center"
                            w="40px"
                            h="40px"
                            borderRadius="50%"
                            boxShadow="0px 4px 24px rgba(0, 0, 0, 0.06)"
                          >
                            <CheckIcon
                              color="accent.900"
                            />
                          </Flex>
                          <Text
                            color="accent.900"
                            fontSize="16px"
                            fontWeight={ 400 }
                            lineHeight="21px"
                          >
                            { area }
                          </Text>
                        </HStack>
                      </GridItem>
                    )
                  })}
                </>
              )
            })}
          </Grid>
        </VStack>
      </Flex>
      <Container
        display={{
          lg: 'none'
        }}
        maxW={{
          base: '100%',
          sm: '640px',
          md: '768px',
          lg: '1024px',
          xl: '1280px',
          '2xl': '1536px'
        }}
        w="100%"
        padding="1rem"
      >
        <Heading
          as="h3"
          margin="16px 0"
          color="accent.900"
          fontSize="32px"
          fontWeight={ 400 }
          lineHeight="36px"
        >
          { props.heading }
        </Heading>
        <Carousel
          options={{
            dragFree: true,
            containScroll: "trimSnaps"
          }}
          emblaPadding="16px 0"
        >
          { props.areas.map(( areaGroup: any[], _groupIndex: number ) => {
            return (
              <VStack
                key={ _groupIndex }
                align="flex-start"
                spacing={ 2 }
                position="relative"
                minW="250px"
                w={{
                  base: '250px'
                }}
              >
                { areaGroup.map( ( area: string[], _index: number ) => (
                  <HStack
                    key={ _index }
                    spacing={ 4 }
                  >
                    <Flex
                      justifyContent="center"
                      alignItems="center"
                      w="40px"
                      h="40px"
                      borderRadius="50%"
                      boxShadow="0px 4px 24px rgba(0, 0, 0, 0.06)"
                    >
                      <CheckIcon
                        color="accent.900"
                      />
                    </Flex>
                    <Text
                      color="accent.900"
                      fontSize="16px"
                      fontWeight={ 400 }
                      lineHeight="21px"
                    >
                      { area }
                    </Text>
                  </HStack>
                ))}
              </VStack>
            )
          })}
        </Carousel>
      </Container>
    </Flex>
  )
}
